module.exports = __webpack_public_path__ + "img/9.8a220f7c.jpg";